<template>
    <div
        :grc_placeholder="placeholder"
        :grc_labeltext="labeltext"
        :grc_labelmode="labelmode"
        :grc_labelwidth="labelwidth"
        :grc_readonly="readonly"    
        :value="component_value"
    >
        <div ref="comp_container" :class="['grccomp_container', labelmode=='table' ? 'grccomp_container_tablemode' : '']">
        <div ref="container_label" 
            :class="['grccomp_container_label', labelmode=='nolabel' ? 'grccomp_container_nolabel' : '', comp_focused ? 'grccomp_container_label_focused' : '']"
            v-bind:style="{ 'width': labelwidth }"
        >{{labeltext}}</div>

        <table style="width:100%;" cellspacing="0" cellpadding="0">
            <tr>
                <td style="width:25%">
                    <GrcKartyaszamTag ref="txtTag1" grc_labeltext="" grc_placeholder=""
                    grc_labelmode="" grc_labelwidth="20px" 
                    v-on:grc-keydown-enter="SetControlToFocus('txtTag2');"
                    v-on:grc-keydown="tagkeydown"
                    v-on:grc-innervaluechanged="Tag1_innervaluechanged"
                    style="padding-right:6px;"
                    />
                </td>
                <td style="width:25%">
                    <GrcKartyaszamTag ref="txtTag2" grc_labeltext="" grc_placeholder=""
                    grc_labelmode="" grc_labelwidth="20px" 
                    v-on:grc-keydown-enter="SetControlToFocus('txtTag3');"
                    v-on:grc-keydown="tagkeydown"
                    v-on:grc-innervaluechanged="Tag2_innervaluechanged"
                    style="padding-right:6px;"
                    />
                </td>
                <td style="width:25%">
                    <GrcKartyaszamTag ref="txtTag3" grc_labeltext="" grc_placeholder=""
                    grc_labelmode="" grc_labelwidth="20px" 
                    v-on:grc-keydown-enter="SetControlToFocus('txtTag4');"
                    v-on:grc-keydown="tagkeydown"
                    v-on:grc-innervaluechanged="Tag3_innervaluechanged"
                    style="padding-right:6px;"
                    />
                </td>
                <td style="width:25%">
                    <GrcKartyaszamTag ref="txtTag4" grc_labeltext="" grc_placeholder=""
                    grc_labelmode="" grc_labelwidth="20px" 
                    v-on:grc-keydown-enter="emit_enter();"
                    v-on:grc-keydown="tagkeydown"
                    />
                </td>
            </tr>
        </table>



        </div>

        <GrcCompErrorBubble ref="ErrorBubble" />
    </div>
</template>


<script>

import Vue from 'vue'
import GrcCompErrorBubble from '../GrcComponents/GrcCompErrorBubble.vue'
import GrcKartyaszamTag from '../GrcComponents/GrcKartyaszamTag.vue'

export default {
  name: 'GrcKartyaszam',
  components: {
    GrcKartyaszamTag,
    GrcCompErrorBubble,
  },
  props: {
    value: String,
    grc_placeholder: String,
    grc_labeltext: String,
    grc_labelmode: String,
    grc_labelwidth: String,
    grc_readonly: String
  },

  data () {
      return {
        placeholder: this.grc_placeholder,
        labeltext: this.grc_labeltext,
        labelmode: this.grc_labelmode,
        labelwidth: this.grc_labelwidth,
        readonly: this.grc_readonly,

        component_value: "",
        prev_component_value: "",

        display_text: "",
        prev_display_text: "",         

        comp_focused: false,
        value_on_focus:"",

      }
  },
  model: {

  },  
  methods:{
    SetLabel(pText)
    {
      this.labeltext = pText;
    },

    SetControlToFocus(pNextComp)
    {
        if (pNextComp == "") { return; }

        this.$refs[pNextComp].SetFocus();
    },

    SetFocus()
    {
      this.$refs.txtTag1.SetFocus();
    },



    ShowError(pText)
    {
      this.$refs.ErrorBubble.ShowError(pText);
    },

    HideError()
    {
      this.$refs.ErrorBubble.HideError();
    },

    Tag1_innervaluechanged(pValue)
    {
        if (pValue.length > 3) { this.SetControlToFocus("txtTag2"); }
    },

    Tag2_innervaluechanged(pValue)
    {
        if (pValue.length > 3) { this.SetControlToFocus("txtTag3"); }
    },

    Tag3_innervaluechanged(pValue)
    {
        if (pValue.length > 3) { this.SetControlToFocus("txtTag4"); }
    },

    tagkeydown(e)
    {
        this.HideError();
    },

    emit_enter()
    {
        this.$emit('grc-keydown-enter');
    },

    SetReadonly(pReadonly)
    {
      if (pReadonly == true)
      {
        this.readonly = "true";
      }
      else
      {
        this.readonly = "false";
      }
    },

    IsReadonly()
    {
      return (this.readonly == "true");
    },

    SetText(pText)
    {
      this.prev_component_value = pText;
      this.component_value = pText;
      this.DisplayValue(pText);
      this.$emit('input', this.component_value);
    },

    GetText()
    {
        return this.$refs.txtTag1.GetText()+this.$refs.txtTag2.GetText()+this.$refs.txtTag3.GetText()+this.$refs.txtTag4.GetText();
        //return this.component_value;
    }


  },
  created()
  {
    if (typeof this.labelmode == "undefined")
    {
      this.labelmode = "nolabel";
    }

    var labelmodes = ["table", "above", "nolabel"];
    if (labelmodes.includes(this.labelmode) == false)
    {
      this.labelmode = "above";
    }

    if (typeof this.labelwidth == "undefined")
    {
      this.labelwidth = "";
    }


    if (typeof this.placeholder == "undefined")
    {
      this.placeholder = "";
    }
  }

}


</script>


<style scoped>

</style>